// Puts markup on the page safely. The app escapes every outside value before it goes into its
// templates; this is the second lock. The markup is parsed into an inert document first (nothing
// in it runs or loads), anything that could run code is removed, and only then is it shown.
const BLOCKED = 'script,iframe,frame,object,embed,link,meta,base,form,noscript,template';
const URL_ATTRS = new Set(['href', 'src', 'xlink:href', 'action', 'formaction', 'srcdoc', 'data']);

export function setHTML(el, html) {
  const doc = new DOMParser().parseFromString(`<body>${html}</body>`, 'text/html');
  for (const n of doc.body.querySelectorAll(BLOCKED)) n.remove();
  for (const n of doc.body.querySelectorAll('*')) {
    for (const a of [...n.attributes]) {
      const name = a.name.toLowerCase(), v = a.value.replace(/[\s\u0000-\u001f]+/g, '').toLowerCase();
      if (name.startsWith('on') || (URL_ATTRS.has(name) && /^(javascript|vbscript|data:text\/html)/.test(v))) n.removeAttribute(a.name);
    }
  }
  el.replaceChildren(...doc.body.childNodes);
}
